export const OP = {
  EQUAL: '=',
  DISTINCT: '<>',
  GREATER_THAN: '>',
  GREATER_EQUAL_THAN: '>=',
  LESS_THAN: '<',
  LESS_EQUAL_THAN: '<=',
  LIKE: 'LIKE',
  NOT_LIKE: 'NOT LIKE',
  IN: 'IN',
  NOT_IN: 'NOT IN',
  IS: 'IS', // solo vale para IS NULL, ediwin ni mira el v2
  IS_NOT: 'IS NOT', // solo vale para IS NOT NULL, ediwin ni mira el v2
};

export const UNION = {
  AND: 'AND',
  OR: 'OR',
  ANDS: ['AND', 'and'],
  ORS: ['OR', 'or'],
};

export const UNIONS = ['AND', 'and', 'OR', 'or'];

export const LOCALE = {
  contains: 'contains',
  startsWith: 'starts with',
  endsWith: 'ends width',
  notContains: 'not contains',
  notStartsWith: 'not starts with',
  notEndsWith: 'not ends with',
  in: 'in',
  notIn: 'not in',
  is: 'is',
  notIs: 'is not',
  equal: 'equal',
  notEqual: 'distinct',
  greaterThan: 'greater than',
  lessThan: 'less than',
  greaterEqualThan: 'greater than or equal to',
  lessEqualThan: 'less than or equal to',

  null: 'NULL',

  from: 'from',
  to: 'to',
  orderBy: 'order by',
  groupBy: 'group by',
  and: 'and',
  or: 'or',

  not: 'NOT',
};
